<script>
	/* eslint-disable svelte/no-at-html-tags */
	// NPM Modules
	import { createEventDispatcher } from 'svelte';

	export let label = undefined;
	export let name = '';
	export let className = '';
	export let value = '';
	export let prefix = '';
	export let suffix = '';
	export let inputType = 'text';
	export let action = 'add';
	export let errors = [];
	export let bgColour = 'bg-gray-500';
	export let textColour = 'text-white';
	export let inputClass = '';
	export let disabled = false;

	const dispatch = createEventDispatcher();

	let addPath =
		'<path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7 14h-5v5h-4v-5h-5v-4h5v-5h4v5h5v4z"/>';
	let removePath =
		'<path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7 14h-14v-4h14v4z"/>';

	function onClick() {
		dispatch(action);
	}
</script>

<div class="text-sm m-1">
	<div
		class="flex items-center p-1 {!action && 'pl-3'} h-8 pr-4 text-white {bgColour}
    {textColour} rounded-full {className}"
		class:opacity-60={disabled}
	>
		{#if action}
			<button on:click={onClick} {disabled} class="p-1 mr-1 focus:outline-none">
				<svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
					{@html action === 'add' ? addPath : removePath}
				</svg>
			</button>
		{/if}
		{#if label}
			<div class="font-semibold select-none text-nowrap {textColour}">{label}</div>
		{/if}
		{#if value !== false}
			{#if prefix}
				<span class="ml-2 text-gray-300 text-nowrap"> {prefix} </span>
			{/if}
			{#if inputType == 'text'}
				<input
					type="text"
					bind:value
					on:change={() => dispatch('change', { name, value })}
					class="border-b border-gray-400 ml-2 text-center w-full focus:outline-none {inputClass} {bgColour} {textColour}"
				/>
			{:else if inputType == 'number'}
				<input
					type="number"
					bind:value
					on:change={() => dispatch('change', { name, value })}
					class="border-b border-gray-400 ml-2 text-center focus:outline-none {inputClass} {bgColour} {textColour}"
				/>
			{/if}
			{#if suffix}
				<span class="ml-2 text-gray-300 text-nowrap"> {suffix} </span>
			{/if}
		{/if}
	</div>
	{#if errors && errors.length}
		<div class="pt-1 text-center text-red-500">{errors[0]}</div>
	{/if}
</div>
